import * as v from "valibot";

export type TaskTab = "inbox" | "all";

export const searchParams = v.object({
  page: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  tab: v.optional(v.picklist(["inbox", "all"])),
});
